export const ZOOM_MAX = 1.6;
export const ZOOM_MIN = 1;
export const ZOOM_STEP = 0.2;

export const calcIsScrollToBottom = (el: HTMLDivElement, threshold = 5) =>
    el.scrollHeight - (el.scrollTop + el.clientHeight) < threshold;
